/**
 * Delivery date + daily cut-off countdown for the cart.
 *
 * Shipping promise shown to the shopper:
 *   • Order BEFORE 3pm AEST today → ships today → arrives in ~7 business days
 *   • Order AFTER 3pm AEST today → ships tomorrow → arrives in ~7 business days from tomorrow
 *
 * Business days = Mon-Fri (skips Sat/Sun). AEST = UTC+10 (fixed; we don't try to
 * handle DST because AU public holidays would require a lookup table anyway).
 */
const AEST_OFFSET_MIN = 10 * 60; // AEST is UTC+10
const CUTOFF_HOUR_AEST = 15; // 3pm
const SHIP_BUSINESS_DAYS = 7;

const toAestDate = (d) => {
  const utcMs = d.getTime() + d.getTimezoneOffset() * 60_000;
  return new Date(utcMs + AEST_OFFSET_MIN * 60_000);
};

const addBusinessDays = (d, n) => {
  const r = new Date(d);
  let added = 0;
  while (added < n) {
    r.setDate(r.getDate() + 1);
    const day = r.getDay();
    if (day !== 0 && day !== 6) added += 1;
  }
  return r;
};

const fmt = (d) =>
  d.toLocaleDateString("en-AU", { weekday: "short", day: "numeric", month: "short" });

/** @returns {{ shipsToday: boolean, countdown: string, arrivesBy: string, cutoff: Date }} */
export function deliveryEstimate(now = new Date()) {
  const aestNow = toAestDate(now);
  const cutoffAest = new Date(aestNow);
  cutoffAest.setHours(CUTOFF_HOUR_AEST, 0, 0, 0);

  const shipsToday = aestNow < cutoffAest;
  const shipDate = shipsToday ? aestNow : addBusinessDays(aestNow, 1);
  // If ship date is a weekend, bump to next Monday
  while (shipDate.getDay() === 0 || shipDate.getDay() === 6) {
    shipDate.setDate(shipDate.getDate() + 1);
  }
  const arrives = addBusinessDays(shipDate, SHIP_BUSINESS_DAYS - 1);

  // Build countdown string for the cutoff
  let countdown = "";
  if (shipsToday) {
    const ms = cutoffAest - aestNow;
    const h = Math.floor(ms / 3_600_000);
    const m = Math.floor((ms % 3_600_000) / 60_000);
    countdown = h > 0 ? `${h}h ${m}m` : `${m}m`;
  }

  return { shipsToday, countdown, arrivesBy: fmt(arrives), cutoff: cutoffAest };
}
